(function ($) {

    $(window).ready(function () {

        /**
         * Sticky Header
         */
        // function stickyNav() {

        //     if ($(window).scrollTop() > 0) {

        //         $('body').addClass('sticky-nav');

        //     } else {

        //         $('body').removeClass('sticky-nav');

        //     }

        // }

        //$(window).on('scroll load', stickyNav);

        /**
         * Request Information Popup
         */

        var body = $('body'),
            requestInformationPopupOpen = $('.request-information-trigger a'),
            scheduleConsultationPopupOpen = $('.schedule-consultation-trigger a'),
            newsletterPopupOpen = $('.newsletter-trigger a'),
            requestInformationSideButton = $('#req-info-btn a'),
            popupClose = $('.PopUpForm--close'),
            popupForm = $('.PopUpForm--Content');

        requestInformationPopupOpen.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            body.addClass('open-request-information');
        });

        scheduleConsultationPopupOpen.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            body.addClass('open-schedule-consultation');
        });


        newsletterPopupOpen.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            body.addClass('open-newsletter');
        });

        requestInformationSideButton.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            body.addClass('open-request-information');
        });

        popupClose.on('click', function (e) {
            body.removeClass('open-request-information');
            body.removeClass('open-schedule-consultation');
            body.removeClass('open-newsletter');
        });

        popupForm.on('click', function (e) {
            e.stopPropagation();
        });

        $(document).on('click', function () {
            body.removeClass('open-request-information');
            body.removeClass('open-schedule-consultation');
            body.removeClass('open-newsletter');
        });

        jQuery(window).on('scroll', function () {
            if (jQuery(window).width() < 992) {
                if (jQuery(window).scrollTop() > 0) {
                    jQuery('body').addClass('mobile-scroll');
                } else {
                    jQuery('body').removeClass('mobile-scroll');
                }
            }
        });
    });

})(jQuery);
